import { fetchHelper } from '@lucidhq/lucidium';
import { useAuth } from "../hooks";
import { adjustOptions } from './prepareFetch';
/**
 * This hook should be used whenever you need to call an API imperatively such as inside an event handler.
 * @returns a function that should be used to call an api imperatively
 * @example
 * ```typescript
 * const MyComponent = () => {
 *    const apiFetch = useApiFetch();
 *
 *    const handleSubmit = async (data) => {
 *      await apiFetch('/posts'); // This here calls the API and returns a promise
 *    }
 *
 *    return (
 *      <form onSubmit={handleSubmit}>
 *         <input type="text" name="field" />
 *         <button type="submit">Submit</button>
 *      </form>
 *    )
 * }
 * ````
 */
export function useAuthFetch() {
    var auth = useAuth();
    return function secureFetch(request, options) {
        return fetchHelper(request, adjustOptions(auth, options));
    };
}
//# sourceMappingURL=useAuthFetch.js.map